function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { HighlightComparisonTable as HighlightComparisonTable$1 } from '@cbhq/cdx-components';
import { mapEntryLink } from '../globals/navlink.js';
import { jsx } from 'react/jsx-runtime';
const HIGHLIGHT_COMPARISON_TABLE_CONTENT_MODEL_ID = 'cdxHighlightComparisonTable';
function HighlightComparisonTable({
  columns = [],
  rowLabels = [],
  heading,
  legalDisclaimer,
  style,
  subhead,
  tableStyle,
  anchor,
  hasSpacingTop
}) {
  const mappedRowLabels = rowLabels.map(({
    fields
  }) => fields);
  const mappedComparisonColumns = columns.map(column => {
    const fields = column.fields;
    const _mapEntryLink = mapEntryLink(fields.ctaButton),
      url = _mapEntryLink.url,
      label = _mapEntryLink.label;
    return _objectSpread(_objectSpread({}, fields), {}, {
      cells: fields.cells.map(cells => cells.fields),
      ctaLabel: label,
      ctaUrl: url
    });
  });
  return /*#__PURE__*/jsx(HighlightComparisonTable$1, {
    headline: heading,
    legalDisclaimer: legalDisclaimer,
    style: style,
    subhead: subhead,
    tableStyle: tableStyle,
    comparisonColumns: mappedComparisonColumns,
    rowLabels: mappedRowLabels,
    hasSpacingTop: hasSpacingTop,
    anchor: anchor
  });
}
export { HIGHLIGHT_COMPARISON_TABLE_CONTENT_MODEL_ID, HighlightComparisonTable };
//# sourceMappingURL=HighlightComparisonTable.js.map
